// import { Fragment, useState } from "react";
// import styled, { keyframes } from "styled-components";

// export default function ServicePopUp({ title, icon, desc }) {
//   const [showPopup, setShowPopup] = useState(false);

//   return (
//     <>
//       <SmallBox onClick={() => setShowPopup(true)}>
//         <i className={icon}></i>
//         <h2>{title}</h2>
//       </SmallBox>
//       {showPopup && (
//         <Overlay onClick={() => setShowPopup(false)}>
//           <ModalContent onClick={(e) => e.stopPropagation()}>
//             <h3>{title}</h3>
//             {desc?.map((item, index) => {
//               return (
//                 <Fragment key={index}>
//                   <h3 style={{ marginBottom: "0px" }}>
//                     {item?.icon}
//                     <b>{item?.title}</b>
//                   </h3>
//                   <h5 style={{ marginBottom: "0px", marginTop: "2px" }}>
//                     {item?.subtitle}
//                   </h5>
//                   <p style={{ marginTop: "0px" }}>{item?.description}</p>
//                 </Fragment>
//               );
//             })}
//             <CloseButton onClick={() => setShowPopup(false)}>Close</CloseButton>
//           </ModalContent>
//         </Overlay>
//       )}
//     </>
//   );
// }

// const SmallBox = styled.div`
//   background-color: #000;
//   flex: 1 1 140px;
//   padding: 5%;
//   text-align: center;
//   border: 1px solid #a78c4c;
//   transition: transform 0.3s, background-color 0.3s;
//   cursor: pointer;

//   &:hover {
//     transform: translateY(-5px);
//     background-color: rgb(167, 140, 76);

//     i,
//     h2 {
//       color: #fff;
//     }
//   }

//   i {
//     font-size: 2.5rem;
//     color: rgb(167, 140, 76);
//     margin-bottom: 10px;
//     transition: color 0.3s;
//   }

//   h2 {
//     font-size: 22px;
//     margin-top: 20px;
//     color: rgb(167, 140, 76);
//     transition: color 0.3s;
//   }
// `;

// const fadeIn = keyframes`
//   from {
//     opacity: 0;
//     transform: scale(0.9);
//   }
//   to {
//     opacity: 1;
//     transform: scale(1);
//   }
// `;

// const Overlay = styled.div`
//   position: fixed;
//   inset: 0;
//   background-color: rgba(0, 0, 0, 0.5);
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   z-index: 9999;
//   padding: 20px;
// `;

// const ModalContent = styled.div`
//   background: #fff;
//   padding: 20px 24px;
//   border-radius: 12px;
//   width: 60%;
//   animation: ${fadeIn} 0.3s ease;

//   h3 {
//     margin-top: 0;
//     font-size: 1.5rem;
//     color: #333;
//   }

//   p {
//     margin-bottom: 20px;
//     color: #666;
//   }
// `;

// const CloseButton = styled.button`
//   background-color: #ff4d4f;
//   color: white;
//   border: none;
//   padding: 10px 16px;
//   border-radius: 6px;
//   font-size: 16px;
//   cursor: pointer;
//   width: 100%;
//   transition: background-color 0.3s;

//   &:hover {
//     background-color: #d9363e;
//   }
// `;


import { Fragment, useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

export default function ServicePopUp({ title, icon, desc }) {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (showPopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [showPopup]);

  return (
    <>
      <SmallBox onClick={() => setShowPopup(true)}>
        <i className={icon}></i>
        <h2>{title}</h2>
      </SmallBox>
    
      {showPopup && (
        <Overlay onClick={() => setShowPopup(false)}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <h3>{title}</h3>
            <ContentArea>
              {desc?.map((item, index) => (
                <Fragment key={index}>
                  <h3 style={{ marginBottom: "0px" }}>
                    {item?.icon}{item?.title}
                  </h3>
                  <h5 style={{ marginBottom: "0px", marginTop: "2px" }}>
                    {item?.subtitle}
                  </h5>
                  <p style={{ marginTop: "0px" }}>{item?.description}</p>
                </Fragment>
              ))}
            </ContentArea>
            <CloseButton onClick={() => setShowPopup(false)}>Close</CloseButton>
          </ModalContent>
        </Overlay>
      )}
    </>
  );
}

const SmallBox = styled.div`
  background-color: #000;
  flex: 1 1 140px;
  padding: 5%;
  text-align: center;
  border: 1px solid #a78c4c;
  transition: transform 0.3s, background-color 0.3s;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
    background-color: rgb(167, 140, 76);

    i,
    h2 {
      color: #fff;
    }
  }

  i {
    font-size: 2.5rem;
    color: rgb(167, 140, 76);
    margin-bottom: 10px;
    transition: color 0.3s;
  }

  h2 {
    font-size: 22px;
    margin-top: 20px;
    color: rgb(167, 140, 76);
    transition: color 0.3s;

     @media (max-width: 768px) {
      font-size: 18px;
    }
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
`;

const ModalContent = styled.div`
  background: #fff;
  padding: 20px 24px;
  border-radius: 12px;
  width: 60%;
  max-height: 80vh;
  overflow: hidden;
  animation: ${fadeIn} 0.3s ease;
  display: flex;
  flex-direction: column;

   @media (max-width: 768px) {
      width: 100%;
    }

  h3 {
    margin-top: 0;
    font-size: 1.5rem;
    color: #333;

     @media (max-width: 768px) {
       font-size: 1rem;
    }
  }

  p {
    margin-bottom: 20px;
    color: #666;
  }
`;

const ContentArea = styled.div`
  overflow-y: auto;
  flex-grow: 1;
  padding-right: 8px; /* for scrollbar spacing */
`;

const CloseButton = styled.button`
  background-color: #ff4d4f;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s;

  &:hover {
    background-color: #d9363e;
  }
`;
